import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-21d444ba")

_pushScopeId("data-v-21d444ba")
const _hoisted_1 = { class: "businessReceiptsInvoicesContent" }
const _hoisted_2 = { class: "pb-4" }
const _hoisted_3 = { class: "businessReceiptsInvoicesFilter" }
const _hoisted_4 = {
  class: "single-filter",
  style: {"width":"min-content"}
}
const _hoisted_5 = { class: "filter-title" }
const _hoisted_6 = { class: "p-relative" }
const _hoisted_7 = { class: "double-filter" }
const _hoisted_8 = { class: "filter-title" }
const _hoisted_9 = { class: "p-relative" }
const _hoisted_10 = { class: "p-relative" }
const _hoisted_11 = {
  class: "single-filter",
  style: {"min-width":"max-content"}
}
const _hoisted_12 = { class: "search-button-wrapper" }
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-search fs-24" }, null, -1)
const _hoisted_14 = {
  id: "desktop-grid",
  class: "desktop-grid"
}
const _hoisted_15 = {
  id: "main-table",
  class: "main-table"
}
const _hoisted_16 = { scope: "col" }
const _hoisted_17 = { class: "checkbox-wrapper" }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_19 = { scope: "col" }
const _hoisted_20 = { scope: "col" }
const _hoisted_21 = { scope: "col" }
const _hoisted_22 = { scope: "col" }
const _hoisted_23 = { scope: "col" }
const _hoisted_24 = { scope: "col" }
const _hoisted_25 = { class: "checkbox-wrapper" }
const _hoisted_26 = /*#__PURE__*/_createVNode("span", { class: "" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("tfoot", null, [
  /*#__PURE__*/_createVNode("tr", { style: {"line-height":"30px","font-weight":"600"} })
], -1)
const _hoisted_28 = { class: "row d-flex justify-content-between justify-content-lg-center" }
const _hoisted_29 = { class: "col-4 col-lg-2 order-modify-container" }
const _hoisted_30 = { class: "col-4 col-lg-2 order-modify-container" }
const _hoisted_31 = { class: "my-1" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_router_link = _resolveComponent("router-link")
  const _component_OverlayModal = _resolveComponent("OverlayModal")

  return (_openBlock(), _createBlock(_component_OverlayModal, {
    isOpen: _ctx.isOpen,
    "onUpdate:isOpen": _cache[12] || (_cache[12] = ($event: any) => (_ctx.isOpen = $event)),
    style: {"max-width":"unset!important"},
    contentClass: "modal-limit",
    modalWidth: _ctx.maxWidth
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('header.select-business-invoices')), 1),
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('label.order_number')), 1),
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_InputNumber, {
                modelValue: _ctx.filter.invoiceNumber,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filter.invoiceNumber = $event)),
                min: 0,
                style: {"width":"100%","height":"48px"},
                allowEmpty: true,
                useGrouping: false
              }, null, 8, ["modelValue"]),
              (_ctx.filter.invoiceNumber)
                ? (_openBlock(), _createBlock("i", {
                    key: 0,
                    class: "icon-f icon-delete-cross fs-10 multiselect-cross-icon2",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filter.invoiceNumber = null))
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('label.created-date')), 1),
            _createVNode("div", null, [
              _createVNode("div", _hoisted_9, [
                _createVNode(_component_Calendar, {
                  modelValue: _ctx.dateRange.fromDate,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.dateRange.fromDate = $event)),
                  selectionMode: "single",
                  dateFormat: "dd/mm/yy",
                  ref: "calendar",
                  onDateSelect: _ctx.dateChanged,
                  placeholder: _ctx.$t('placeholder.from')
                }, null, 8, ["modelValue", "onDateSelect", "placeholder"]),
                (_ctx.dateRange.fromDate)
                  ? (_openBlock(), _createBlock("i", {
                      key: 0,
                      class: "icon-f icon-delete-cross fs-10 multiselect-cross-icon3",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dateRange.fromDate = null))
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_10, [
                _createVNode(_component_Calendar, {
                  modelValue: _ctx.dateRange.toDate,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.dateRange.toDate = $event)),
                  selectionMode: "single",
                  dateFormat: "dd/mm/yy",
                  minDate: _ctx.dateRange.fromDate,
                  ref: "calendar",
                  onDateSelect: _ctx.dateChanged,
                  placeholder: _ctx.$t('placeholder.to')
                }, null, 8, ["modelValue", "minDate", "onDateSelect", "placeholder"]),
                (_ctx.dateRange.toDate)
                  ? (_openBlock(), _createBlock("i", {
                      key: 0,
                      class: "icon-f icon-delete-cross fs-10 multiselect-cross-icon3",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.dateRange.toDate = null))
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode("span", {
              class: "clear-all",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.clearFilter && _ctx.clearFilter(...args)))
            }, _toDisplayString(_ctx.$t('button.clearAll')), 1)
          ]),
          _createVNode("div", _hoisted_12, [
            _createVNode("button", {
              type: "button",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
            }, [
              _hoisted_13
            ])
          ])
        ]),
        _createVNode("div", _hoisted_14, [
          _createVNode("table", _hoisted_15, [
            _createVNode("thead", null, [
              _createVNode("tr", null, [
                _createVNode("th", _hoisted_16, [
                  _createVNode("span", _hoisted_17, [
                    _createVNode("input", {
                      class: "inp-cbx",
                      checked: _ctx.checkAll,
                      onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.selectAll && _ctx.selectAll(...args))),
                      id: "onSelectAll",
                      type: "checkbox",
                      style: {"display":"none"}
                    }, null, 40, ["checked"]),
                    _createVNode("label", {
                      class: ["cbx same-size w-100", { 'single-line': true }],
                      for: "onSelectAll"
                    }, [
                      _hoisted_18
                    ])
                  ])
                ]),
                _createVNode("th", _hoisted_19, _toDisplayString(_ctx.$t('label.invoice-number')), 1),
                _createVNode("th", _hoisted_20, _toDisplayString(_ctx.$t('accounting.for')), 1),
                _createVNode("th", _hoisted_21, _toDisplayString(_ctx.$t('label.amount')), 1),
                _createVNode("th", _hoisted_22, _toDisplayString(_ctx.$t('label.amount-left-cover')), 1),
                _createVNode("th", _hoisted_23, _toDisplayString(_ctx.$t('label.created-date')), 1),
                _createVNode("th", _hoisted_24, _toDisplayString(_ctx.$t('label.creator-user')), 1)
              ])
            ]),
            _createVNode("tbody", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.invoiceToView, (row, index) => {
                return (_openBlock(), _createBlock("tr", { key: index }, [
                  _createVNode("td", null, [
                    _createVNode("span", _hoisted_25, [
                      _createVNode("input", {
                        class: "inp-cbx",
                        checked: _ctx.isChecked(row.baseAccountingDocumentId),
                        value: row.baseAccountingDocumentId,
                        onChange: ($event: any) => (_ctx.onSelect(row.baseAccountingDocumentId)),
                        id: 'customer-' + row.baseAccountingDocumentId,
                        type: "checkbox",
                        style: {"display":"none"}
                      }, null, 40, ["checked", "value", "onChange", "id"]),
                      _createVNode("label", {
                        class: ["cbx same-size w-100", { 'single-line': true }],
                        for: 'customer-' + row.baseAccountingDocumentId
                      }, [
                        _hoisted_26
                      ], 8, ["for"])
                    ])
                  ]),
                  _createVNode("td", null, [
                    _createVNode(_component_router_link, {
                      to: {
                                        name: 'businessInvoiceView',
                                        params: { invoiceId: row.baseAccountingDocumentId, clientId: _ctx.clientId }
                                    },
                      class: "text-link",
                      target: "_blank"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(row.documentNumber), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _createVNode("td", null, _toDisplayString(row.for), 1),
                  _createVNode("td", null, _toDisplayString(_ctx.formatAmount(row.amount)), 1),
                  _createVNode("td", null, _toDisplayString(_ctx.formatAmount(row.leftToCoverInLocal)), 1),
                  _createVNode("td", null, _toDisplayString(row.createdDate), 1),
                  _createVNode("td", null, _toDisplayString(row.creator), 1)
                ]))
              }), 128))
            ]),
            _hoisted_27
          ])
        ]),
        _createVNode("div", _hoisted_28, [
          _createVNode("div", _hoisted_29, [
            _createVNode("button", {
              type: "button",
              class: "order-modify-button-wrapper dark-circle-button",
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
            }, _toDisplayString(_ctx.$t('button.cancel')), 1)
          ]),
          _createVNode("div", _hoisted_30, [
            _createVNode("button", {
              type: "button",
              class: "order-modify-button-wrapper btn-green",
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
            }, [
              _createVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('button.add')), 1)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["isOpen", "modalWidth"]))
})